import React from 'react';
import WholesalePartsHubSectionHeader from '../wholesale-parts-hub-section-header';

interface Props {
  title: string;
  id?: string;
}

const WholesalePartsHubSection: React.FC<Props> = ({ title, id, children }) => (
  <section>
    <WholesalePartsHubSectionHeader id={id}>
      {title}
    </WholesalePartsHubSectionHeader>
    <div className="content">{children}</div>
    {/* language=CSS */}
    <style jsx>{`
      section {
        position: relative;
      }
    `}</style>
  </section>
);

export default WholesalePartsHubSection;
